export default {
  ARRIVAL_NOT_ROUNDED: `<0>{{ arrivalTime }}</0> <1>{{ arrivalDate }}</1>`,
  ARRIVAL_ROUNDED: `<0>{{ arrivalTime }}</0> (Arrondi à <0>{{ arrivalRoundedTime }}</0>) <1>{{ arrivalDate }}</1>`,
  LEAVE_NOT_ROUNDED: `<0>{{ leaveTime }}</0> <1>{{ leaveDate }}</1>`,
  LEAVE_ROUNDED: `<0>{{ leaveTime }}</0> (Arrondi à <0>{{ leaveRoundedTime }}</0>) <1>{{ leaveDate }}</1>`,
  SHIFT_HOURS: `<0>{{ position }}</0> {{ start }} de <0>{{ startTime }}</0> à <0>{{ endTime }}</0>`,
  PLANNED_HOURS: `<0>{{ shift }}</0> à l'horaire`,
  BREAK_HOURS: `<0>{{ unpaidBreak }}</0> en pauses non payées`,
  PRESENT_HOURS: `<0>{{ present }}</0> poinçonné`,
  PAID_HOURS: `<0>{{ paid }}</0> payé`,
  CREATE: `Créer une carte de temps`,
  ABSENT_OR_ON_VACATION: `L'employé est absent ou en congé`,
  VALIDATION_VIEW: `Vue de validation`,
  REGULAR_VIEW: `Retour à la vue régulière`,
  PUNCH_CARD_REQUIRES_ACTION: `Une carte de temps requiert votre attention!`,
  PUNCH_CARD_REQUIRES_ACTION_other: `{{ count }} cartes de temps requièrent votre attention!`,
  SHIFTS_WITH_NO_PUNCH_CARD: `Un quart de travail n'a pas de carte de temps correspondante!`,
  SHIFTS_WITH_NO_PUNCH_CARD_other: `{{ count }} quarts de travail n'ont pas de carte de temps correspondante!`,
  DELETE_BUTTON: {
    TITLE: `Supprimer la carte de temps`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette carte de temps?`,
    PRIMARY_ACTION: `Supprimer`
  },
  LOCATION: {
    LABEL: `Lancer le terminal de poinçonnage à cet emplacement:`,
    DESCRIPTION: ``
  },
  USER_ID: `Utilisateur`,
  SUMMARY: `Sommaire`,
  HOURS_SUMMARY: `Temps total`,
  ADDITIONAL_INFORMATION: `Informations complémentaires`,
  FLAGS: ``,
  BREAKS: `Pauses`,
  TRANSFERS: `Transferts`,
  TRANSFER_POSITION: `Transfert de position`,
  TRANSFER_PROJECT: `Transfert de projet`,
  WAGE_PREMIUMS: `Primes salariales`,
  DISABLED_OVERWRITE_OVERTIME: `Calcul temps supplémentaire désactivé`,
  PROJECT: `Projet`,
  TEAM: `Équipe`,
  ARRIVAL: `Arrivée`,
  DEPARTURE: `Sortie`,
  EXPECTED_LOCATION: `Emplacement prévu`,
  LEAVE: `Départ`,
  ARRIVAL_LOCATION: `Emplacement d'entrée`,
  LEAVE_LOCATION: `Emplacement de sortie`,
  ARRIVAL_COORDINATES: `Coordonnées d'entrée`,
  LEAVE_COORDINATES: `Coordonnées de sortie`,
  ARRIVAL_COORDINATES_ERROR: `Les coordonnées d'entrée ne correspondent pas à l'emplacement prévu`,
  LEAVE_COORDINATES_ERROR: `Les coordonnées de départ ne correspondent pas à l'emplacement prévu`,
  APPROVED_MANUALLY: `Approuvée manuellement`,
  DISABLE_ARRIVAL_ROUNDING: `Arrondissement entrée désactivé`,
  DISABLE_LEAVE_ROUNDING: `Arrondissement sortie désactivé`,
  PHONE_NUMBER: `Numéro de téléphone`,
  DATE_RANGE_EXCEEDED: {
    TITLE: `Plage de dates trop longue`,
    DESCRIPTION: `Vous avez essayé de télécharger trop de cartes de temps, veuillez mettre un filtre de date qui ne dépasse pas 4 semaines.`
  },
  NO_DATE_FILTER: {
    TITLE: `Aucun filtre de date`,
    DESCRIPTION: `Veuillez sélectionner un filtre de dates afin de charger les cartes de temps.`
  },
  LIST: {
    TITLE: `Liste des cartes de temps`
  },
  flags: {
    PUNCHED_IN_EARLY_DETAIL: `{{ time }} trop tôt`,
    PUNCHED_IN_LATE_DETAIL: `{{ time }} trop tard`,
    PUNCHED_OUT_EARLY_DETAIL: `{{ time }} trop tôt`,
    PUNCHED_OUT_LATE_DETAIL: `{{ time }} trop tard`,
    ISINEARLY: `Arrivé trop tôt`,
    ISINLATE: `Arrivé trop tard`,
    ISOUTEARLY: `Parti trop tôt`,
    ISOUTLATE: `Parti trop tard`,
    NOTPUNCHEDIN: `Aucun poinçon d'entrée`,
    NOTPUNCHEDOUT: `Aucun poinçon de sortie`,
    NOSHIFT: `Aucun quart associé`,
    DUPLICATECARD: `Carte de temps dupliquée`,
    MISSINGPUNCHRULES: `Aucune règle de poinçon`,
    NOCLOCKEDTIME: `Aucun temps enregistré`,
    LOCATION_CONFLICTS: `Conflits d'emplacement de poinçon`
  },
  STATUSES: {
    APPROVED: `Approuvée`,
    APPROVAL_REQUIRED: `Approbation manuelle requise`,
    PUNCH_RULE_APPROVAL: `Approuver avec les règles de carte de temps`,
    NEEDS_CORRECTION: `Corrections nécessaires`,
    NO_SHIFT: `Aucun quart de travail associé`,
    MISSING_PUNCH_RULES: `La position n'a pas de règles de carte de temps`,
    LOCATION_CONFLICTS: `Conflits d'emplacement de poinçon`,
    null: `Aucun statut`
  },
  csv: {
    CSV_NAME: `export_liste_cartes_temps_{{ range }}`
  },
  pdf: {
    PDF_NAME: `export_liste_cartes_temps_{{ range }}`,
    TITLE: `Rapport de validation des heures poinçonnées`,
    GENERATED_BY: `Généré par`,
    NAME: `Nom`,
    DATE: `Date`,
    DAY: `Jour`,
    SHIFT: `Quart de travail`,
    SHIFTTOTAL: `Durée du quart`,
    SHIFT_TOTAL: `Total des heures planifiées`,
    WORKED: `Poinçonné`,
    WORKEDROUNDED: `Arrondi`,
    WORKEDTOTAL: `Durée payée`,
    WORKED_TOTAL: `Total des heures payés`,
    DIFFERENCE: `Différence`,
    POSITION: `Position`
  },
  CREATE_PUNCH_CARDS_MODAL: {
    TITLE: `Créer des cartes de temps`,
    SUMMARY: `Une carte de temps sera crée pour chaque quart non poinçonné qui est sélectionné.`,
    DESCRIPTION: `Les cartes de temps crée devront être validées et approuvées.`,
    ERROR_LOADING: `Erreur en chargeant les quarts de travail non poinçonnés.`,
    ERROR_CREATING_CARDS: `Erreur en créant les cartes de temps.`,
    LOCKEDPUNCHCARD: `Ce quart est vérouillé`,
    ISABSENT: `Cet employé est absent`,
    ISONTIMEOFF: `Cet employé est en congé`,
    CREATEFORABSENCETIMEOFF: 'Créer des cartes de temps pour les employés absents ou en congé'
  },
  LAUNCH_PUNCH_TERMINAL_MODAL: {
    TITLE: `Lancer le terminal de poinçonnage`,
    SUMMARY: ``
  },
  diffs: {
    SEE_MODIFICATIONS: `Voir l'historique des modifications`,
    TITLE: `Historique de modifications de la carte de temps`,
    SUMMARY: ``,
    TIMESTAMP: `<1>{{ time }}</1> {{ date }} par <0>{{ name }}</0>`,
    BEFORE: `Avant`,
    AFTER: `Après`,
    NO_BREAKS: `Aucune pause`,
    NO_TRANSFERS: `Aucun transfert`,
    NO_WAGE_PREMIUMS: `Aucune prime`,
    USERID_ASSIGNED: `<1>{{ after }}</1> a été assigné`,
    USERID_UNASSIGNED: `<0>{{ before }}</0> a été enlevé`,
    USERID_CHANGED: `<1>{{ after }}</1> a été assigné à la place de <0>{{ before }}</0>`,
    SHIFT_ASSOCIATED: `Associée à un quart de travail`,
    SHIFT_UNASSOCIATED: `Dissociée d'un quart de travail`,
    SHIFT_CHANGED: `Quart de travail associé a été changé`,
    POSITIONID_CHANGED: `Position changée de <0>{{ before }}</0> à <1>{{ after }}</1>`,
    ARRIVAL_CHANGED: `Entrée changé de <0>{{ before }}</0> à <1>{{ after }}</1>`,
    ARRIVAL_ADDED: `Entrée ajoutée <1>{{ after }}</1>`,
    ARRIVAL_REMOVED: `Entrée enlevée`,
    LEAVE_CHANGED: `Sortie changé de <0>{{ before }}</0> à <1>{{ after }}</1>`,
    LEAVE_ADDED: `Sortie ajouté <1>{{ after }}</1>`,
    LEAVE_REMOVED: `Sortie enlevé`,
    BREAKS_CHANGED: `Pauses modifiées`,
    TRANSFERS_CHANGED: `Transferts modifiés`,
    WAGE_PREMIUMS_CHANGED: `Primes modifiées`,
    STATUS_CHANGED: `Statut changé de <0>{{ before }}</0> à <1>{{ after }}</1>`,
    ARRIVAL_ROUNDING_DISABLED: `L'arrondissement de l'heure d'entrée a été désactivé`,
    ARRIVAL_ROUNDING_ENABLED: `L'arrondissement de l'heure d'entrée a été activé`,
    LEAVE_ROUNDING_DISABLED: `L'arrondissement de l'heure de sortie a été désactivé`,
    LEAVE_ROUNDING_ENABLED: `L'arrondissement de l'heure de sortie a été activé`,
    APPROVED_MANUALLY: `Approuvé manuellement`,
    UNAPPROVED_MANUALLY: `Approbation retirée manuellement`
  },
  form: {
    COMMENT: `Commentaire de l'employé:`,
    ARRIVAL_MUST_BE_BEFORE_LEAVE: `L'heure d'entrée doit être avant l'heure de sortie.`,
    NO_SHIFT: `Pas de quart de travail`,
    SHIFT_HAS_CHANGED_SINCE_PUNCH_CREATION: `Le quart de travail a été changé depuis que la carte de temps a été crée, veuillez cliquer ici pour syncroniser les données du quart à la carte de temps.`,
    LONG_PUNCHCARD_WARNING: `La carte de temps a une durée supérieure à 12 heures. Veuillez vérifier que les heures sont correctes.`,
    CREATE: {
      TITLE: `Créer une carte de temps`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modifier la carte de temps`,
      SUMMARY: ``
    },
    BREAKS_TRANSFERS_PREMIUMS_PROJECTS: `Projet, pauses, transferts et primes`,
    BREAKS: {
      LABEL: `Pauses`,
      SUMMARY: `Ajoutez des pauses payées et non payées à la carte de temps.`,
      UNPLANNED: `Pause non planifiée`,
      NEW_BREAK: `Ajouter une pause`,
      NOT_CONTAINED_IN_PUNCH_CARD: `L'heure de pause n'est pas entre le début et la fin de la carte de temps.`
    },
    TRANSFERS: {
      TITLE: `Transferts`,
      SUMMARY: `Ajoutez des transferts à la carte de temps.`,
      NEW_TRANSFER: `Ajouter un transfert`,
      NOT_CONTAINED_IN_PUNCH_CARD: `L'heure de transfert n'est pas entre le début et la fin de la carte de temps.`
    },
    USERID: {
      LABEL: `Employé`,
      DESCRIPTION: ``
    },
    RANGE_TO_LOAD_SHIFTS: {
      LABEL: `Période à charger pour les quarts`,
      DESCRIPTION: `Sert à déterminer quelle période sera utilisée pour remplir le champ du quart de travail en fonction de l'employé sélectionné.`
    },
    SHIFTID: {
      LABEL: `Quart de travail`,
      DESCRIPTION: `Si aucun quart n'est trouvé, vérifiez la date et l'employé assigné à la carte de temps.`,
      EMPTY_PLACEHOLDER: `Aucun quart de travail trouvé`
    },
    STATUS: {
      LABEL: `Statut`,
      DESCRIPTION: ``
    },
    ADDITIONALINFO: {
      LABEL: `Informations complémentaires`,
      PLACEHOLDER: `Entrez les informations ici`,
      DESCRIPTION: `Sert à ajouter du contexte à la carte de temps et potentiellement indiquer un traitement spécifique.`
    },
    REFERENCEDATE: {
      LABEL: `Date`,
      DESCRIPTION: ``
    },
    ARRIVALTIME: {
      LABEL: `Heure d'entrée`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DISABLEARRIVALROUNDING: {
      LABEL: `Désactiver l'arrondissement de l'heure d'entrée`,
      DESCRIPTION: ``
    },
    ARRIVAL_ROUNDED: `Heure d'entrée arrondie à <0>{{ arrivalTimeRounded }}</0>`,
    CLEAR_ARRIVAL: `Enlever l'heure d'entrée`,
    LEAVETIME: {
      LABEL: `Heure de sortie`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DISABLELEAVEROUNDING: {
      LABEL: `Désactiver l'arrondissement de l'heure de sortie`,
      DESCRIPTION: ``
    },
    LEAVE_ROUNDED: `Heure de sortie arrondie à <0>{{ leaveTimeRounded }}</0>`,
    CLEAR_LEAVE: `Enlever l'heure de sortie`,
    BREAKSTART: {
      LABEL: `Début`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à indiquer l'heure de début de la pause.`
    },
    BREAKEND: {
      LABEL: `Fin`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à indiquer l'heure de fin de la pause.`
    },
    BREAKPAID: {
      LABEL: `Payée`,
      DESCRIPTION: `Sert à indiquer si la pause est payée ou non.`
    },
    BREAKREASON: {
      LABEL: `Raison`,
      DESCRIPTION: `Sert à ajouter du contexte à propos d'une pause prise par un employé.`,
      PLACEHOLDER: `Ajoutez une courte raison à la pause`
    },
    TRANSFERSTART: {
      LABEL: `Début`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à indiquer l'heure à laquelle le transfert a eu lieu.`
    },
    TRANSFERTOPOSITION: {
      LABEL: `Position`,
      DESCRIPTION: `Sert à indiquer vers quelle position le transfert a été effectué.`
    },
    TRANSFERTOPROJECT: {
      LABEL: `Projet`,
      DESCRIPTION: `Sert à indiquer vers quel projet le transfert a été effectué.`
    },
    PROJECTID: {
      LABEL: `Projet`,
      PLACEHOLDER: `Choisissez un projet`,
      DESCRIPTION: ``
    },
    TEAMID: {
      LABEL: `Équipe`,
      PLACEHOLDER: `Choisissez une équipe`,
      DESCRIPTION: ``
    },
    TAGS: {
      LABEL: `Étiquettes`,
      PLACEHOLDER: `Ajoutez des étiquettes`,
      DESCRIPTION: ``
    }
  },
  validation: {
    LIST: {
      TITLE: `Validation des cartes de temps`
    },
    TOTAL_PLANNED: `<0>{{ totalPlanned }}</0> heures planifiées au total`,
    TOTAL_WORKED: `<0>{{ totalRegular }}</0> heures travaillées au total`,
    PLANNED_HOURS_SINGLE: `À l'horaire <0>{{ shiftStart }}-{{ shiftEnd }}</0>`,
    WORKED_HOURS_SINGLE: `Poinçonné <0>{{ workedStart }}-{{ workedEnd }}</0>`,
    ROUNDED_HOURS_SINGLE: `Payé <0>{{ workedStartRounded }}-{{ workedEndRounded }}</0>`,
    PLANNED_DURATION: `À l'horaire (avec pauses) <0>{{ shiftTotal }}</0>`,
    WORKED_DURATION: `Poinçonné (sans pauses) <0>{{ workedTotal }}</0>`,
    PAID_DURATION: `Payé (sans pauses) <0>{{ paidTotal }}</0>`,
    DIFFERENCE: `Différence <0>{{ difference }}</0>`
  },
  UNPLANNED: `Non planifiée : {{reason}}`,
  PAID: `PAYÉE`,
  NOT_ENDED_YET: `Pas encore terminée`,
  IMPORT_PUNCH: `Importer des cartes de temps`,
  PUNCH_CARD_LOCKED: `Cette carte de temps est vérouillée, veuillez contacter votre administrateur pour la créer/modifier.`,
  PUNCH_CARD_LOCKED_CAN_EDIT: `Cette carte de temps est vérouillée, mais vous pouvez la modifier.`,
  LOCK_PUNCH_CARDS: `Vérouiller les cartes de temps`,
  PUNCH_LOCK_DATE_MODAL: {
    TITLE: `Modifier la date de verouillage des cartes de temps`,
    SUMMARY: ``,
    PUNCHCARDLOCKDATE: {
      LABEL: `Date de verouillage`,
      DESCRIPTION: `Il sera seulement possible de modifier ou créer des cartes de temps commençant après cette date.`,
      PLACEHOLDER: `Entrez une date`
    }
  },
  import: {
    TITLE: {
      TITLE: `Importer des cartes de temps`,
      SUMMARY: ``
    },
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    EMPLOYEENUMBER_DESC: `Le numéro de l'employé dans Merinio.`,
    POSITION_CODE: `Code de position`,
    POSITIONCODE_DESC: `Doit être un code de position choisi par votre administrateur.`,
    DATE: `Date`,
    DATE_DESC: `La date du poinçon doit être inscrite dans le format <1>YYYY-MM-DD</1>, par exemple <1>2010-01-30</1> pour le 30 janvier 2010.`,
    TIME: `Heure`,
    TIME_DESC: `L'heure du poinçon doit être inscrite dans le format <1>HH:mm</1>, par exemple <1>14:00</1> pour 14h.`,
    DOWNLOAD_TEMPLATE: `Télécharger un modèle de fichier`,
    MISSING_HEADERS: `Entête manquante: <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Entêtes manquantes: <0>{{value}}</0>`,
    TEMPLATE_FILE_NAME: `Importation_de_poincons`,
    PUNCHES_SAVING_FAILED: `Il y a <0>{{count}}</0> carte de temps qui n'a pas été sauvegardé.`,
    PUNCHES_SAVING_FAILED_other: `Il y a <0>{{count}}</0> cartes de temps qui n'ont pas été sauvegardés.`,
    PUNCHES_NOT_VALID: `Il y a <0>{{count}}</0> champ invalide.`,
    PUNCHES_NOT_VALID_other: `Il y a <0>{{count}}</0> champs invalides.`,
    SHIFT: `Quart de travail`,
    NO_SHIFT: `Aucun quart de travail`,
    ARRIVAL: `Entrée`,
    DEPARTURE: `Sortie`,
    NO_DEPARTURE: `Aucun sortie`
  },
  SHIFT_DUPLICATED: `Le quart de travail sélectionné possède déjà une carte de temps. Cliquez ici afin de la voir.`,
  CREATE_A_SHIFT: `Aucun quart de travail sélectionné, choissisez un dans la liste ou cliquez ici pour en créer un.`,
  DATE_FILTER_CHANGED: `Filtre de date changé`,
  PUNCH_CARD_NOT_CONTAINED_IN_FILTER: `La carte de temps que tu viens de créer n'était pas comprise dans le filtre.`,
  SEE_EMPLOYEE_SCHEDULE: `Voir l'horaire de l'employé`
}
